var combinedarray;
console.log('collection swatches file');


//

window.createswatches = window.createswatches || function() {
  console.log('createswatches callerd function');
  const urls = [
    "/collections/all/products.json?page=1&limit=1000",
    "/collections/all/products.json?page=2&limit=1000",
    "/collections/all/products.json?page=3&limit=1000",
    "/collections/all/products.json?page=4&limit=1000",
  ];

  Promise.all(
    urls.map((url) => fetch(url).then((response) => response.json()))
  ).then((data) => {
    var firstdataset = data[0].products;
    combinedarray = firstdataset.concat(
      data[1].products,
      data[2].products,
      data[3].products
    );

    assignswatches(combinedarray);
  });
};

window.initializeShowMoreSwatches = window.initializeShowMoreSwatches || function() {
  setTimeout(function(){  

    // Volver a seleccionar los botones cada vez que se llama a la función
    document.querySelectorAll('.morecolorsct').forEach(function(showMoreButton) {
      // Verificar si ya se añadió el evento para evitar múltiples enlaces
      if (!showMoreButton.classList.contains('initialized')) {
        const hiddenSwatches = showMoreButton.nextElementSibling;
        
        // Si el próximo elemento es el contenedor de swatches ocultos
        if (hiddenSwatches && hiddenSwatches.classList.contains('hidden-swatches')) {
          showMoreButton.addEventListener('click', function() {
            hiddenSwatches.classList.toggle('showin');
            showMoreButton.style.display = 'none'; // Ocultar el botón después de hacer clic
          });

          // Marcar el botón como inicializado
          showMoreButton.classList.add('initialized');
        }
      }
    });

  }, 200);  
};

// Función `assignswatches` sigue sin cambios
window.assignswatches = window.assignswatches || function(combinedarray) {
  document.querySelectorAll(".grid-product").forEach((element, index) => {
    var loop = 0;
    var ptitle = element.getAttribute("data-product-title");
    var pid = element.getAttribute("data-product-id");   

    console.log('assignswatches called');

    combinedarray.forEach((product) => {
      const fullTitle = product.title;
      const titleParts = fullTitle.split(" - "); 
      const dataTitle = titleParts[0];

      if (dataTitle == ptitle) {
        loop += 1;

        console.log('Matching title found:', dataTitle);

        var productid = product.id;
        var image = product.images[0].src;
        var producthandle = product.handle;
        var variant = product.variants[0].title;
        var colorsplit = variant.split(" / ");
        var color = colorsplit[0];
        var colorhandleized = color
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/\//g, "-");

        var collectionurl = `/collections/${collectionhandle}/products/${producthandle}`;
        var swatchitem = `
        <a reference="${productid}" href="${collectionurl}" class="swatch-link">
            <span data-variant-color="${color}" data-url="${collectionurl}" class="variantcolor collectionswatch color-swatch color-swatch-collection color-swatch--small color-swatch--${colorhandleized} color-swatch--with-image" data-tooltip="${color}" data-variant-image="${image}&width=500" style="background-image: url('${swatchurl}${colorhandleized}_50x.png'); background-color: ${color};" data-uw-styling-context="true">
                <span class="visually-hidden" data-uw-styling-context="true">${color}</span>
            </span>
        </a>`; 

        var colorGrid = document.querySelector(
          `.colorgrid${pid}:not(.swatchadded${colorhandleized})`
        );

        if (colorGrid) {
          if (loop == 6) { 
            colorGrid.insertAdjacentHTML("beforeend", swatchitem);
        
            colorGrid.insertAdjacentHTML(
              "beforeend",
              '<span class="morecolorsct"></span>'
            );
            var loopadjust = loop - 4;
            var moreColorsCt = colorGrid.querySelector(".morecolorsct");
            if (moreColorsCt && loop > 6) {
              moreColorsCt.innerHTML = `<span class="colornumber">+${loopadjust}</span>`;
            }
          } else if (loop > 6) {
            let hiddenSwatchesContainer = colorGrid.querySelector('.hidden-swatches');
            if (!hiddenSwatchesContainer) {
              hiddenSwatchesContainer = document.createElement('div');
              hiddenSwatchesContainer.classList.add('hidden-swatches');
              colorGrid.appendChild(hiddenSwatchesContainer);
            }
            hiddenSwatchesContainer.insertAdjacentHTML("beforeend", swatchitem);
            
            var loopadjust = loop - 6;
            var moreColorsCt = colorGrid.querySelector(".morecolorsct");
            if (moreColorsCt) {
              moreColorsCt.innerHTML = `<span class="colornumber">+${loopadjust}</span>`;
            }
          } else {
            colorGrid.insertAdjacentHTML("beforeend", swatchitem);
          }
        
          colorGrid.classList.add(`swatchadded${colorhandleized}`);
        } else {
          console.warn(`colorGrid no encontrado para el pid: ${pid}`);
        }

        
      }
    });
  });
};




document.addEventListener('DOMContentLoaded', function() {
  
  window.createswatches();
  setTimeout(function(){    
  
    window.initializeShowMoreSwatches();
    console.log("hello world");
  }, 1000);

});







